export const part1Data = [
  {
    id: "p1_1",
    english: "The man is reviewing documents at his desk.",
    chunks: [
      { korean: "그 남자가", english: "The man" },
      { korean: "검토하고 있다", english: "is reviewing" },
      { korean: "서류를", english: "documents" },
      { korean: "자신의 책상에서", english: "at his desk" },
    ],
  },
  {
    id: "p1_2",
    english: "People are waiting in line at the ticket counter.",
    chunks: [
      { korean: "사람들이", english: "People" },
      { korean: "기다리고 있다", english: "are waiting" },
      { korean: "줄을서서", english: "in line" },
      { korean: "티켓카운터에서", english: "at the ticket counter" },
    ],
  },
  {
    id: "p1_3",
    english: "The workers are standing on the scaffold.",
    chunks: [
      { korean: "작업자들이", english: "The workers" },
      { korean: "서 있다", english: "are standing" },
      { korean: "비계 위에", english: "on the scaffold" },
    ],
  },
  {
    id: "p1_4",
    english: "The woman is holding a broomstick.",
    chunks: [
      { korean: "그 여자가", english: "The woman" },
      { korean: "들고 있다", english: "is holding" },
      { korean: "빗자루를", english: "a broomstick" },
    ],
  },
  {
    id: "p1_5",
    english: "The woman is appreciating the paintings.",
    chunks: [
      { korean: "그 여자가", english: "The woman" },
      { korean: "감상하고 있다", english: "is appreciating" },
      { korean: "그림들을", english: "the paintings" },
    ],
  },
  {
    id: "p1_6",
    english: "The woman is leaning against the wall.",
    chunks: [
      { korean: "그 여자가", english: "The woman" },
      { korean: "기대고 있다", english: "is leaning" },
      { korean: "벽에", english: "against the wall" },
    ],
  },
  {
    id: "p1_7",
    english: "The women are sitting across from each other.",
    chunks: [
      { korean: "여자들이", english: "The women" },
      { korean: "앉아 있다", english: "are sitting" },
      { korean: "서로 마주보고", english: "across from each other" },
    ],
  },
  {
    id: "p1_8",
    english: "The women are sitting side by side.",
    chunks: [
      { korean: "여자들이", english: "The women" },
      { korean: "앉아 있다", english: "are sitting" },
      { korean: "나란히", english: "side by side" },
    ],
  },
  {
    id: "p1_9",
    english: "There are sailors on the dock.",
    chunks: [
      { korean: "있다선원들이", english: "There are sailors" },
      { korean: "부두에", english: "on the dock" },
    ],
  },
  {
    id: "p1_10",
    english: "The ducks are swimming around in the lake.",
    chunks: [
      { korean: "오리들이", english: "The ducks" },
      { korean: "헤엄치고 있다", english: "are swimming around" },
      { korean: "호수에서", english: "in the lake" },
    ],
  },
  {
    id: "p1_11",
    english: "The passengers are about to board the ferry.",
    chunks: [
      { korean: "승객들이", english: "The passengers" },
      { korean: "막 타려고 한다", english: "are about to board" },
      { korean: "페리를", english: "the ferry" },
    ],
  },
  {
    id: "p1_12",
    english: "The ships are docked at the wharf.",
    chunks: [
      { korean: "배들이", english: "The ships" },
      { korean: "정박해 있다", english: "are docked" },
      { korean: "부두에", english: "at the wharf" },
    ],
  },
  {
    id: "p1_13",
    english: "The woman is paying for some merchandise.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "지불하고 있다", english: "is paying" },
      { korean: "상품에 대해", english: "for some merchandise" },
    ],
  },
  {
    id: "p1_14",
    english: "Someone's purchases are being bagged at a the store.",
    chunks: [
      { korean: "누군가의 구매품이", english: "Someone's purchases" },
      { korean: "포장되고 있다", english: "are being bagged" },
      { korean: "상점에서", english: "at a the store" },
    ],
  },
  {
    id: "p1_15",
    english: "The customer is handing money to a the clerk.",
    chunks: [
      { korean: "고객이", english: "The customer" },
      { korean: "건네고 있다 돈을", english: "is handing money" },
      { korean: "점원에게", english: "to a the clerk" },
    ],
  },
  {
    id: "p1_16",
    english: "The man is wheeling the cart.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "밀고 있다", english: "is wheeling" },
      { korean: "카트를", english: "the cart" },
    ],
  },
  {
    id: "p1_17",
    english: "The woman is walking along the sidewalk.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "걷고 있다", english: "is walking" },
      { korean: "인도를 따라", english: "along the sidewalk" },
    ],
  },
  {
    id: "p1_18",
    english: "The woman is holding up some objects.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "들고 있다", english: "is holding up" },
      { korean: "몇 가지 물건을", english: "some objects" },
    ],
  },
  {
    id: "p1_19",
    english: "The woman is walking on the crosswalk.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "걷고 있다", english: "is walking" },
      { korean: "횡단보도에서", english: "on the crosswalk" },
    ],
  },
  {
    id: "p1_20",
    english: "The travelers are collecting their luggage.",
    chunks: [
      { korean: "여행자들이", english: "The travelers" },
      { korean: "수집하고 있다", english: "are collecting" },
      { korean: "그들의 짐을", english: "their luggage" },
    ],
  },
  {
    id: "p1_21",
    english: "The airplane is being refueled.",
    chunks: [
      { korean: "비행기가", english: "The airplane" },
      { korean: "연료를 공급받고 있다", english: "is being refueled" },
    ],
  },
  {
    id: "p1_22",
    english: "The passengers are disembarking from an airplane.",
    chunks: [
      { korean: "승객들이", english: "The passengers" },
      { korean: "내리고 있다", english: "are disembarking" },
      { korean: "비행기에서", english: "from an airplane" },
    ],
  },
  {
    id: "p1_23",
    english: "Several people are exiting the plane.",
    chunks: [
      { korean: "여러 사람들이", english: "Several people" },
      { korean: "나가고 있다", english: "are exiting" },
      { korean: "비행기에서", english: "the plane" },
    ],
  },
  {
    id: "p1_24",
    english: "The aircraft is approaching the airport.",
    chunks: [
      { korean: "항공기가", english: "The aircraft" },
      { korean: "접근하고 있다", english: "is approaching" },
      { korean: "공항에", english: "the airport" },
    ],
  },
  {
    id: "p1_25",
    english: "The airplane has just taken off.",
    chunks: [
      { korean: "비행기가", english: "The airplane" },
      { korean: "방금 이륙했다", english: "has just taken off" },
    ],
  },
  {
    id: "p1_26",
    english: "The vehicle is hoisted into the air.",
    chunks: [
      { korean: "차량이", english: "The vehicle" },
      { korean: "들어올려지고 있다", english: "is hoisted" },
      { korean: "공중으로", english: "into the air" },
    ],
  },
  {
    id: "p1_27",
    english: "The airplane is leaving the ground.",
    chunks: [
      { korean: "비행기가", english: "The airplane" },
      { korean: "이륙하고 있다", english: "is leaving" },
      { korean: "지면에서", english: "the ground" },
    ],
  },
  {
    id: "p1_28",
    english: "The woman is handing over the boarding pass.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "건네주고 있다", english: "is handing over" },
      { korean: "탑승권을", english: "the boarding pass" },
    ],
  },
  {
    id: "p1_29",
    english: "The woman is pushing a luggage cart.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "밀고 있다", english: "is pushing" },
      { korean: "수하물 카트를", english: "a luggage cart" },
    ],
  },
  {
    id: "p1_30",
    english: "The airplane has landed on the runway.",
    chunks: [
      { korean: "비행기가", english: "The airplane" },
      { korean: "착륙했다", english: "has landed" },
      { korean: "활주로에", english: "on the runway" },
    ],
  },
  {
    id: "p1_31",
    english: "The runway is being repaved.",
    chunks: [
      { korean: "활주로가", english: "The runway" },
      { korean: "재포장되고 있다", english: "is being repaved" },
    ],
  },
  {
    id: "p1_32",
    english: "The ground crew is guiding an aircraft to the gate.",
    chunks: [
      { korean: "지상 승무원이", english: "The ground crew" },
      { korean: "안내하고 있다", english: "is guiding" },
      { korean: "항공기를", english: "an aircraft" },
      { korean: "게이트로", english: "to the gate" },
    ],
  },
  {
    id: "p1_33",
    english: "The passengers are boarding the plane.",
    chunks: [
      { korean: "승객들이", english: "The passengers" },
      { korean: "탑승하고 있다", english: "are boarding" },
      { korean: "비행기에", english: "the plane" },
    ],
  },
  {
    id: "p1_34",
    english: "The people are passing through security screening.",
    chunks: [
      { korean: "사람들이", english: "The people" },
      { korean: "통과하고 있다", english: "are passing through" },
      { korean: "보안 검색을", english: "security screening" },
    ],
  },
  {
    id: "p1_35",
    english: "Some luggage has been placed on the conveyor belt.",
    chunks: [
      { korean: "일부 수하물이", english: "Some luggage" },
      { korean: "놓여졌다", english: "has been placed" },
      { korean: "컨베이어 벨트 위에", english: "on the conveyor belt" },
    ],
  },
  {
    id: "p1_36",
    english: "The passengers are fastening their seat belts.",
    chunks: [
      { korean: "승객들이", english: "The passengers" },
      { korean: "매고 있다", english: "are fastening" },
      { korean: "그들의 안전벨트를", english: "their seat belts" },
    ],
  },
  {
    id: "p1_37",
    english: "Some passengers are claiming their luggage.",
    chunks: [
      { korean: "일부 승객들이", english: "Some passengers" },
      { korean: "찾고 있다", english: "are claiming" },
      { korean: "그들의 수하물을", english: "their luggage" },
    ],
  },
  {
    id: "p1_38",
    english: "Airport security is assisting a passenger.",
    chunks: [
      { korean: "공항 보안 요원이", english: "Airport security" },
      { korean: "도와주고 있다", english: "is assisting" },
      { korean: "승객을", english: "a passenger" },
    ],
  },
  {
    id: "p1_39",
    english: "A piece of luggage is placed on the conveyor belt.",
    chunks: [
      { korean: "한 개의 수하물이", english: "A piece of luggage" },
      { korean: "놓여져 있다", english: "is placed" },
      { korean: "컨베이어 벨트 위에", english: "on the conveyor belt" },
    ],
  },
  {
    id: "p1_40",
    english: "There are many people on board the aircraft.",
    chunks: [
      { korean: "많은 사람들이 있다", english: "There are many people" },
      { korean: "탑승한", english: "on board" },
      { korean: "항공기에", english: "the aircraft" },
    ],
  },
  {
    id: "p1_41",
    english: "The flight attendant is closing the overhead compartments.",
    chunks: [
      { korean: "승무원이", english: "The flight attendant" },
      { korean: "닫고 있다", english: "is closing" },
      { korean: "머리 위 수납장을", english: "the overhead compartments" },
    ],
  },
  {
    id: "p1_42",
    english: "The flight attendant is making a safety demonstration.",
    chunks: [
      { korean: "승무원이", english: "The flight attendant" },
      { korean: "하고 있다", english: "is making" },
      { korean: "안전 시범을", english: "a safety demonstration" },
    ],
  },
  {
    id: "p1_43",
    english: "The men are sitting opposite each other.",
    chunks: [
      { korean: "남자들이", english: "The men" },
      { korean: "앉아 있다", english: "are sitting" },
      { korean: "서로 마주보고", english: "opposite each other" },
    ],
  },
  {
    id: "p1_44",
    english: "The aircraft is airborne.",
    chunks: [
      { korean: "항공기가", english: "The aircraft" },
      { korean: "공중에 떠 있다", english: "is airborne" },
    ],
  },
  {
    id: "p1_45",
    english: "The man is resting his feet on his suitcase.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "놓고 있다", english: "is resting" },
      { korean: "그의 발을", english: "his feet" },
      { korean: "그의 여행 가방 위에", english: "on his suitcase" },
    ],
  },
  {
    id: "p1_46",
    english: "Some luggage has been loaded onto the cart.",
    chunks: [
      { korean: "일부 수하물이", english: "Some luggage" },
      { korean: "실렸다", english: "has been loaded" },
      { korean: "카트 위에", english: "onto the cart" },
    ],
  },
  {
    id: "p1_47",
    english: "The passenger is retrieving his luggage.",
    chunks: [
      { korean: "승객이", english: "The passenger" },
      { korean: "찾고 있다", english: "is retrieving" },
      { korean: "그의 수하물을", english: "his luggage" },
    ],
  },
  {
    id: "p1_48",
    english: "The flight attendant is handing out blankets.",
    chunks: [
      { korean: "승무원이", english: "The flight attendant" },
      { korean: "나눠주고 있다", english: "is handing out" },
      { korean: "담요를", english: "blankets" },
    ],
  },
  {
    id: "p1_49",
    english: "A passenger is reaching for an item in the overhead compartment.",
    chunks: [
      { korean: "승객이", english: "A passenger" },
      { korean: "손을 뻗고 있다", english: "is reaching" },
      { korean: "물건을 향해", english: "for an item" },
      {
        korean: "머리 위 수납장에 있는",
        english: "in the overhead compartment",
      },
    ],
  },
  {
    id: "p1_50",
    english: "The cupboard door is being closed.",
    chunks: [
      { korean: "찬장 문이", english: "The cupboard door" },
      { korean: "닫히고 있다", english: "is being closed" },
    ],
  },
  {
    id: "p1_51",
    english: "The woman is entering the security area.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "들어가고 있다", english: "is entering" },
      { korean: "보안 구역에", english: "the security area" },
    ],
  },
  {
    id: "p1_52",
    english: "The woman is carrying a piece of luggage.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "들고 있다", english: "is carrying" },
      { korean: "수하물 하나를", english: "a piece of luggage" },
    ],
  },
  {
    id: "p1_53",
    english: "The man is waving to his friends.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "손을 흔들고 있다", english: "is waving" },
      { korean: "그의 친구들에게", english: "to his friends" },
    ],
  },
  {
    id: "p1_54",
    english: "The man is resting a bag on his lap.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "놓고 있다", english: "is resting" },
      { korean: "가방을", english: "a bag" },
      { korean: "그의 무릎 위에", english: "on his lap" },
    ],
  },
  {
    id: "p1_55",
    english: "There is a painting hung on the fence.",
    chunks: [
      { korean: "그림이", english: "There is a painting" },
      { korean: "걸려 있다", english: "hung" },
      { korean: "울타리에", english: "on the fence" },
    ],
  },
  {
    id: "p1_56",
    english: "The man is concentrating on his subject.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "집중하고 있다", english: "is concentrating" },
      { korean: "그의 과제에", english: "on his subject" },
    ],
  },
  {
    id: "p1_57",
    english: "The man is carving a sculpture.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "조각하고 있다", english: "is carving" },
      { korean: "조각품을", english: "a sculpture" },
    ],
  },
  {
    id: "p1_58",
    english: "The girl is posing for a photo.",
    chunks: [
      { korean: "소녀가", english: "The girl" },
      { korean: "포즈를 취하고 있다", english: "is posing" },
      { korean: "사진을 위해", english: "for a photo" },
    ],
  },
  {
    id: "p1_59",
    english: "The girl is having her portrait painted.",
    chunks: [
      { korean: "소녀가", english: "The girl" },
      {
        korean: "자신의 초상화를 그리게 하고 있다",
        english: "is having her portrait painted",
      },
    ],
  },
  {
    id: "p1_60",
    english: "The spectators are applauding the performers.",
    chunks: [
      { korean: "관객들이", english: "The spectators" },
      { korean: "박수를 치고 있다", english: "are applauding" },
      { korean: "공연자들에게", english: "the performers" },
    ],
  },
  {
    id: "p1_61",
    english: "There is a choir singing on the stage.",
    chunks: [
      { korean: "합창단이", english: "There is a choir" },
      { korean: "노래하고 있다", english: "singing" },
      { korean: "무대 위에서", english: "on the stage" },
    ],
  },
  {
    id: "p1_62",
    english: "Some artwork has drawn the visitors' attention.",
    chunks: [
      { korean: "몇몇 예술 작품이", english: "Some artwork" },
      { korean: "끌었다", english: "has drawn" },
      { korean: "방문객들의 관심을", english: "the visitors' attention" },
    ],
  },
  {
    id: "p1_63",
    english: "The people are lining up for a performance.",
    chunks: [
      { korean: "사람들이", english: "The people" },
      { korean: "줄을 서고 있다", english: "are lining up" },
      { korean: "공연을 위해", english: "for a performance" },
    ],
  },
  {
    id: "p1_64",
    english: "A picture is being painted.",
    chunks: [
      { korean: "그림이", english: "A picture" },
      { korean: "그려지고 있다", english: "is being painted" },
    ],
  },
  {
    id: "p1_65",
    english: "The paintings are hung on the wall.",
    chunks: [
      { korean: "그림들이", english: "The paintings" },
      { korean: "걸려 있다", english: "are hung" },
      { korean: "벽에", english: "on the wall" },
    ],
  },
  {
    id: "p1_66",
    english: "Some artwork is available for purchase.",
    chunks: [
      { korean: "몇몇 예술 작품이", english: "Some artwork" },
      { korean: "가능하다", english: "is available" },
      { korean: "구매가", english: "for purchase" },
    ],
  },
  {
    id: "p1_67",
    english: "The storekeeper is hanging up a sign.",
    chunks: [
      { korean: "가게주인이", english: "The storekeeper" },
      { korean: "걸고 있다", english: "is hanging up" },
      { korean: "간판을", english: "a sign" },
    ],
  },
  {
    id: "p1_68",
    english: "Some graphs are mounted on the wall.",
    chunks: [
      { korean: "몇몇 그래프들이", english: "Some graphs" },
      { korean: "부착되어 있다", english: "are mounted" },
      { korean: "벽에", english: "on the wall" },
    ],
  },
  {
    id: "p1_69",
    english: "Several visitors are viewing artwork in the gallery.",
    chunks: [
      { korean: "여러 방문객들이", english: "Several visitors" },
      { korean: "보고 있다", english: "are viewing" },
      { korean: "예술 작품을", english: "artwork" },
      { korean: "갤러리에서", english: "in the gallery" },
    ],
  },
  {
    id: "p1_70",
    english: "Some people are gathered for a meeting.",
    chunks: [
      { korean: "몇몇 사람들이", english: "Some people" },
      { korean: "모여 있다", english: "are gathered" },
      { korean: "회의를 위해", english: "for a meeting" },
    ],
  },
  {
    id: "p1_71",
    english: "Some notices are pinned to the bulletin board.",
    chunks: [
      { korean: "몇몇 공지사항이", english: "Some notices" },
      { korean: "고정되어 있다", english: "are pinned" },
      { korean: "게시판에", english: "to the bulletin board" },
    ],
  },
  {
    id: "p1_72",
    english: "The man is setting up a musical instrument.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "설치하고 있다", english: "is setting up" },
      { korean: "악기를", english: "a musical instrument" },
    ],
  },
  {
    id: "p1_73",
    english: "Some guests are seated at the table.",
    chunks: [
      { korean: "몇몇 손님들이", english: "Some guests" },
      { korean: "앉아 있다", english: "are seated" },
      { korean: "테이블에", english: "at the table" },
    ],
  },
  {
    id: "p1_74",
    english: "The woman is framing a picture.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "액자를 만들고 있다", english: "is framing" },
      { korean: "사진을", english: "a picture" },
    ],
  },
  {
    id: "p1_75",
    english: "The people are playing different instruments.",
    chunks: [
      { korean: "사람들이", english: "The people" },
      { korean: "연주하고 있다", english: "are playing" },
      { korean: "다양한 악기를", english: "different instruments" },
    ],
  },
  {
    id: "p1_76",
    english: "The street musician is surrounded by a crowd.",
    chunks: [
      { korean: "거리 음악가가", english: "The street musician" },
      { korean: "둘러싸여 있다", english: "is surrounded" },
      { korean: "군중에 의해", english: "by a crowd" },
    ],
  },
  {
    id: "p1_77",
    english: "The guitarist is performing in public.",
    chunks: [
      { korean: "기타리스트가", english: "The guitarist" },
      { korean: "공연하고 있다", english: "is performing" },
      { korean: "공공장소에서", english: "in public" },
    ],
  },
  {
    id: "p1_78",
    english: "The band is performing in the concert hall.",
    chunks: [
      { korean: "밴드가", english: "The band" },
      { korean: "공연하고 있다", english: "is performing" },
      { korean: "콘서트홀에서", english: "in the concert hall" },
    ],
  },
  {
    id: "p1_79",
    english: "The performers are acting in front of an audience.",
    chunks: [
      { korean: "공연자들이", english: "The performers" },
      { korean: "연기하고 있다", english: "are acting" },
      { korean: "관객 앞에서", english: "in front of an audience" },
    ],
  },
  {
    id: "p1_80",
    english: "The conductor is standing in front of the performers.",
    chunks: [
      { korean: "지휘자가", english: "The conductor" },
      { korean: "서 있다", english: "is standing" },
      { korean: "공연자들 앞에", english: "in front of the performers" },
    ],
  },
  {
    id: "p1_81",
    english: "Several musicians are marching in a line.",
    chunks: [
      { korean: "여러 음악가들이", english: "Several musicians" },
      { korean: "행진하고 있다", english: "are marching" },
      { korean: "일렬로", english: "in a line" },
    ],
  },
  {
    id: "p1_82",
    english: "The audience is giving a standing ovation.",
    chunks: [
      { korean: "관객들이", english: "The audience" },
      {
        korean: "기립 박수를 치고 있다",
        english: "is giving a standing ovation",
      },
    ],
  },
  {
    id: "p1_83",
    english: "The audience is applauding the musicians.",
    chunks: [
      { korean: "관객들이", english: "The audience" },
      { korean: "박수를 치고 있다", english: "is applauding" },
      { korean: "음악가들에게", english: "the musicians" },
    ],
  },
  {
    id: "p1_84",
    english: "The crowd is cheering at a music event.",
    chunks: [
      { korean: "군중이", english: "The crowd" },
      { korean: "환호하고 있다", english: "is cheering" },
      { korean: "음악 행사에서", english: "at a music event" },
    ],
  },
  {
    id: "p1_85",
    english: "The people are admiring the statue in the art museum.",
    chunks: [
      { korean: "사람들이", english: "The people" },
      { korean: "감상하고 있다", english: "are admiring" },
      { korean: "조각상을", english: "the statue" },
      { korean: "미술관에서", english: "in the art museum" },
    ],
  },
  {
    id: "p1_86",
    english: "The spectators are applauding the performer.",
    chunks: [
      { korean: "관람객들이", english: "The spectators" },
      { korean: "박수를 치고 있다", english: "are applauding" },
      { korean: "공연자에게", english: "the performer" },
    ],
  },
  {
    id: "p1_87",
    english: "The man is carrying a tripod.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "들고 있다", english: "is carrying" },
      { korean: "삼각대를", english: "a tripod" },
    ],
  },
  {
    id: "p1_88",
    english: "The man is adjusting the camera lens.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "조정하고 있다", english: "is adjusting" },
      { korean: "카메라 렌즈를", english: "the camera lens" },
    ],
  },
  {
    id: "p1_89",
    english: "The man is setting up a tripod.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "설치하고 있다", english: "is setting up" },
      { korean: "삼각대를", english: "a tripod" },
    ],
  },
  {
    id: "p1_90",
    english: "The artist is painting a mural.",
    chunks: [
      { korean: "예술가가", english: "The artist" },
      { korean: "그리고 있다", english: "is painting" },
      { korean: "벽화를", english: "a mural" },
    ],
  },
  {
    id: "p1_91",
    english: "The woman is kneeling down to take a picture.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "무릎을 꿇고 있다", english: "is kneeling down" },
      { korean: "사진을 찍기 위해", english: "to take a picture" },
    ],
  },
  {
    id: "p1_92",
    english: "The woman is admiring the scenery.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "감상하고 있다", english: "is admiring" },
      { korean: "경치를", english: "the scenery" },
    ],
  },
  {
    id: "p1_93",
    english: "The sculpture is being displayed in the gallery.",
    chunks: [
      { korean: "조각품이", english: "The sculpture" },
      { korean: "전시되고 있다", english: "is being displayed" },
      { korean: "갤러리에", english: "in the gallery" },
    ],
  },
  {
    id: "p1_94",
    english: "There is a statue standing in the garden.",
    chunks: [
      { korean: "동상이", english: "There is a statue" },
      { korean: "서 있다", english: "standing" },
      { korean: "정원에", english: "in the garden" },
    ],
  },
  {
    id: "p1_95",
    english: "The water is splashing in the fountain.",
    chunks: [
      { korean: "물이", english: "The water" },
      { korean: "튀고 있다", english: "is splashing" },
      { korean: "분수대에서", english: "in the fountain" },
    ],
  },
  {
    id: "p1_96",
    english: "There are people strolling in the park.",
    chunks: [
      { korean: "사람들이", english: "There are people" },
      { korean: "산책하고 있다", english: "strolling" },
      { korean: "공원에서", english: "in the park" },
    ],
  },
  {
    id: "p1_97",
    english: "Some technology is being used in the art classroom.",
    chunks: [
      { korean: "몇몇 기술이", english: "Some technology" },
      { korean: "사용되고 있다", english: "is being used" },
      { korean: "미술 교실에서", english: "in the art classroom" },
    ],
  },
  {
    id: "p1_98",
    english: "The woman is dipping a brush into the paint bucket.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "담그고 있다", english: "is dipping" },
      { korean: "붓을", english: "a brush" },
      { korean: "페인트통에", english: "into the paint bucket" },
    ],
  },
  {
    id: "p1_99",
    english: "The structure is being taken down.",
    chunks: [
      { korean: "구조물이", english: "The structure" },
      { korean: "철거되고 있다", english: "is being taken down" },
    ],
  },
  {
    id: "p1_100",
    english: "The excavator is digging a hole.",
    chunks: [
      { korean: "굴착기가", english: "The excavator" },
      { korean: "파고 있다", english: "is digging" },
      { korean: "구멍을", english: "a hole" },
    ],
  },
  {
    id: "p1_101",
    english: "The man is operating the machine.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "작동하고 있다", english: "is operating" },
      { korean: "기계를", english: "the machine" },
    ],
  },
  {
    id: "p1_102",
    english: "The cement is being poured on the ground.",
    chunks: [
      { korean: "시멘트가", english: "The cement" },
      { korean: "부어지고 있다", english: "is being poured" },
      { korean: "땅 위에", english: "on the ground" },
    ],
  },
  {
    id: "p1_103",
    english: "He's unloading the rocks.",
    chunks: [
      { korean: "그가", english: "He" },
      { korean: "내리고 있다", english: "is unloading" },
      { korean: "돌들을", english: "the rocks" },
    ],
  },
  {
    id: "p1_104",
    english: "He's putting on safety gear.",
    chunks: [
      { korean: "그가", english: "He" },
      { korean: "착용하고 있다", english: "is putting on" },
      { korean: "안전 장비를", english: "safety gear" },
    ],
  },
  {
    id: "p1_105",
    english: "He's moving a wheelbarrow.",
    chunks: [
      { korean: "그가", english: "He" },
      { korean: "옮기고 있다", english: "is moving" },
      { korean: "손수레를", english: "a wheelbarrow" },
    ],
  },
  {
    id: "p1_106",
    english: "He's loading the rocks.",
    chunks: [
      { korean: "그가", english: "He" },
      { korean: "싣고 있다", english: "is loading" },
      { korean: "돌들을", english: "the rocks" },
    ],
  },
  {
    id: "p1_107",
    english: "The man is tying a piece of rope.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "묶고 있다", english: "is tying" },
      { korean: "하나의 밧줄을", english: "a piece of rope" },
    ],
  },
  {
    id: "p1_108",
    english: "The man is climbing up the pole.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "올라가고 있다", english: "is climbing up" },
      { korean: "기둥을", english: "the pole" },
    ],
  },
  {
    id: "p1_109",
    english: "The man is wearing safety gear.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "착용하고 있다", english: "is wearing" },
      { korean: "안전 장비를", english: "safety gear" },
    ],
  },
  {
    id: "p1_110",
    english: "The worker is climbing up the ladder.",
    chunks: [
      { korean: "작업자가", english: "The worker" },
      { korean: "올라가고 있다", english: "is climbing up" },
      { korean: "사다리를", english: "the ladder" },
    ],
  },
  {
    id: "p1_111",
    english: "The worker is taking off his helmet.",
    chunks: [
      { korean: "작업자가", english: "The worker" },
      { korean: "벗고 있다", english: "is taking off" },
      { korean: "그의 헬멧을", english: "his helmet" },
    ],
  },
  {
    id: "p1_112",
    english: "The truck is hauling construction materials.",
    chunks: [
      { korean: "트럭이", english: "The truck" },
      { korean: "운반하고 있다", english: "is hauling" },
      { korean: "건설 자재를", english: "construction materials" },
    ],
  },
  {
    id: "p1_113",
    english: "The crane is being used to move the crate.",
    chunks: [
      { korean: "크레인이", english: "The crane" },
      { korean: "사용되고 있다", english: "is being used" },
      { korean: "상자를 옮기는 데", english: "to move the crate" },
    ],
  },
  {
    id: "p1_114",
    english: "The worker is operating the excavator.",
    chunks: [
      { korean: "작업자가", english: "The worker" },
      { korean: "조작하고 있다", english: "is operating" },
      { korean: "굴착기를", english: "the excavator" },
    ],
  },
  {
    id: "p1_115",
    english: "The machine is being repaired.",
    chunks: [
      { korean: "기계가", english: "The machine" },
      { korean: "수리되고 있다", english: "is being repaired" },
    ],
  },
  {
    id: "p1_116",
    english: "The cargo is being lifted by the forklift.",
    chunks: [
      { korean: "화물이", english: "The cargo" },
      { korean: "들어올려지고 있다", english: "is being lifted" },
      { korean: "지게차에 의해", english: "by the forklift" },
    ],
  },
  {
    id: "p1_117",
    english: "The man is unloading the crates.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "내리고 있다", english: "is unloading" },
      { korean: "상자들을", english: "the crates" },
    ],
  },
  {
    id: "p1_118",
    english: "The forklift is being used to transport the goods.",
    chunks: [
      { korean: "지게차가", english: "The forklift" },
      { korean: "사용되고 있다", english: "is being used" },
      { korean: "운반하는데", english: "to transport" },
      { korean: "물품들을", english: "the goods" },
    ],
  },
  {
    id: "p1_119",
    english: "The goods are stacked on the pallets.",
    chunks: [
      { korean: "물품들이", english: "The goods" },
      { korean: "쌓여 있다", english: "are stacked" },
      { korean: "팔레트 위에", english: "on the pallets" },
    ],
  },
  {
    id: "p1_120",
    english: "The worker is putting on a safety suit.",
    chunks: [
      { korean: "작업자가", english: "The worker" },
      { korean: "입고 있다", english: "is putting on" },
      { korean: "안전복을", english: "a safety suit" },
    ],
  },
  {
    id: "p1_121",
    english: "The forklift is carrying equipment.",
    chunks: [
      { korean: "지게차가", english: "The forklift" },
      { korean: "운반하고 있다", english: "is carrying" },
      { korean: "장비를", english: "equipment" },
    ],
  },
  {
    id: "p1_122",
    english: "The worker has stopped the vehicle.",
    chunks: [
      { korean: "작업자가", english: "The worker" },
      { korean: "멈췄다", english: "has stopped" },
      { korean: "차량을", english: "the vehicle" },
    ],
  },
  {
    id: "p1_123",
    english: "The road has been repaved.",
    chunks: [
      { korean: "도로가", english: "The road" },
      { korean: "재포장되었다", english: "has been repaved" },
    ],
  },
  {
    id: "p1_124",
    english: "A worker is holding a sign.",
    chunks: [
      { korean: "작업자가", english: "A worker" },
      { korean: "들고 있다", english: "is holding" },
      { korean: "표지판을", english: "a sign" },
    ],
  },
  {
    id: "p1_125",
    english: "A man is carrying traffic cones.",
    chunks: [
      { korean: "남자가", english: "A man" },
      { korean: "운반하고 있다", english: "is carrying" },
      { korean: "교통 콘을", english: "traffic cones" },
    ],
  },
  {
    id: "p1_126",
    english: "The man is holding a shovel.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "들고 있다", english: "is holding" },
      { korean: "삽을", english: "a shovel" },
    ],
  },
  {
    id: "p1_127",
    english: "The man is welding.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "용접하고 있다", english: "is welding" },
    ],
  },
  {
    id: "p1_128",
    english: "The woman is holding a safety helmet.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "들고 있다", english: "is holding" },
      { korean: "안전모를", english: "a safety helmet" },
    ],
  },
  {
    id: "p1_129",
    english: "The woman is wearing protective goggles.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "착용하고 있다", english: "is wearing" },
      { korean: "보호 고글을", english: "protective goggles" },
    ],
  },
  {
    id: "p1_130",
    english: "The man is flipping a light switch.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "켜고 있다", english: "is flipping" },
      { korean: "전등 스위치를", english: "a light switch" },
    ],
  },
  {
    id: "p1_131",
    english: "The truck is loaded with construction materials.",
    chunks: [
      { korean: "트럭이", english: "The truck" },
      { korean: "실려 있다", english: "is loaded" },
      { korean: "건설 자재로", english: "with construction materials" },
    ],
  },
  {
    id: "p1_132",
    english: "The man is sawing the wood.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "톱질하고 있다", english: "is sawing" },
      { korean: "나무를", english: "the wood" },
    ],
  },
  {
    id: "p1_133",
    english: "The man is using a rectangular saw.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "사용하고 있다", english: "is using" },
      { korean: "직사각형 톱을", english: "a rectangular saw" },
    ],
  },
  {
    id: "p1_134",
    english: "One of the men is hammering a nail into the wall.",
    chunks: [
      { korean: "남자 중 한 명이", english: "One of the men" },
      { korean: "망치질하고 있다", english: "is hammering" },
      { korean: "못을 벽에", english: "a nail into the wall" },
    ],
  },
  {
    id: "p1_135",
    english: "The boards are piled on top of each other.",
    chunks: [
      { korean: "판자들이", english: "The boards" },
      { korean: "쌓여 있다", english: "are piled" },
      { korean: "서로 위에", english: "on top of each other" },
    ],
  },
  {
    id: "p1_136",
    english: "They are unloading cardboard boxes from the van.",
    chunks: [
      { korean: "그들은", english: "They" },
      { korean: "내리고 있다", english: "are unloading" },
      { korean: "골판지 상자들을", english: "cardboard boxes" },
      { korean: "벤에서", english: "from the van" },
    ],
  },
  {
    id: "p1_137",
    english: "The woman is labeling a package.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "라벨을 붙이고 있다", english: "is labeling" },
      { korean: "소포에", english: "a package" },
    ],
  },
  {
    id: "p1_138",
    english: "The man is using a wrench.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "사용하고 있다", english: "is using" },
      { korean: "렌치를", english: "a wrench" },
    ],
  },
  {
    id: "p1_139",
    english: "The man is fastening the handrail with a power drill.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "고정하고 있다", english: "is fastening" },
      { korean: "난간을", english: "the handrail" },
      { korean: "전동 드릴로", english: "with a power drill" },
    ],
  },
  {
    id: "p1_140",
    english: "The man is tightening a screw with a screwdriver.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "조이고 있다", english: "is tightening" },
      { korean: "나사를", english: "a screw" },
      { korean: "드라이버로", english: "with a screwdriver" },
    ],
  },
  {
    id: "p1_141",
    english: "The man is filling some buckets with liquid.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "채우고 있다", english: "is filling" },
      { korean: "몇 개의 양동이를", english: "some buckets" },
      { korean: "액체로", english: "with liquid" },
    ],
  },
  {
    id: "p1_142",
    english: "The man is holding a tool.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "들고 있다", english: "is holding" },
      { korean: "도구를", english: "a tool" },
    ],
  },
  {
    id: "p1_143",
    english: "The courier is on duty.",
    chunks: [
      { korean: "배달원이", english: "The courier" },
      { korean: "근무 중이다", english: "is on duty" },
    ],
  },
  {
    id: "p1_144",
    english: "Some packages are being delivered to clients.",
    chunks: [
      { korean: "몇몇 소포들이", english: "Some packages" },
      { korean: "배달되고 있다", english: "are being delivered" },
      { korean: "고객들에게", english: "to clients" },
    ],
  },
  {
    id: "p1_145",
    english: "The delivery driver is accepting payments.",
    chunks: [
      { korean: "배달 기사가", english: "The delivery driver" },
      { korean: "받고 있다", english: "is accepting" },
      { korean: "결제를", english: "payments" },
    ],
  },
  {
    id: "p1_146",
    english: "The parcel has been delivered to the client.",
    chunks: [
      { korean: "소포가", english: "The parcel" },
      { korean: "배달되었다", english: "has been delivered" },
      { korean: "고객에게", english: "to the client" },
    ],
  },
  {
    id: "p1_147",
    english: "The ladders are leaning against the wall.",
    chunks: [
      { korean: "사다리들이", english: "The ladders" },
      { korean: "기대어 있다", english: "are leaning" },
      { korean: "벽에", english: "against the wall" },
    ],
  },
  {
    id: "p1_148",
    english: "Some boxes are stacked on top of each other.",
    chunks: [
      { korean: "몇몇 상자들이", english: "Some boxes" },
      { korean: "쌓여 있다", english: "are stacked" },
      { korean: "서로 위에", english: "on top of each other" },
    ],
  },
  {
    id: "p1_149",
    english: "The cupboard door is left open.",
    chunks: [
      { korean: "찬장 문이", english: "The cupboard door" },
      { korean: "열려 있다", english: "is left open" },
    ],
  },
  {
    id: "p1_150",
    english: "Some containers are being emptied.",
    chunks: [
      { korean: "몇몇 용기들이", english: "Some containers" },
      { korean: "비워지고 있다", english: "are being emptied" },
    ],
  },
  {
    id: "p1_151",
    english: "The driver is pulling over the truck.",
    chunks: [
      { korean: "운전자가", english: "The driver" },
      { korean: "세우고 있다", english: "is pulling over" },
      { korean: "트럭을", english: "the truck" },
    ],
  },
  {
    id: "p1_152",
    english: "The men are wearing tool belts.",
    chunks: [
      { korean: "남자들이", english: "The men" },
      { korean: "착용하고 있다", english: "are wearing" },
      { korean: "공구 벨트를", english: "tool belts" },
    ],
  },
  {
    id: "p1_153",
    english: "One of the men is using a forklift.",
    chunks: [
      { korean: "남자들 중 한 명이", english: "One of the men" },
      { korean: "사용하고 있다", english: "is using" },
      { korean: "지게차를", english: "a forklift" },
    ],
  },
  {
    id: "p1_154",
    english: "One of the women is chopping some vegetables.",
    chunks: [
      { korean: "여자들 중 한 명이", english: "One of the women" },
      { korean: "썰고 있다", english: "is chopping" },
      { korean: "몇몇 채소를", english: "some vegetables" },
    ],
  },
  {
    id: "p1_155",
    english: "The woman is stirring something in a pot.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "젓고 있다", english: "is stirring" },
      { korean: "무언가를", english: "something" },
      { korean: "냄비에서", english: "in a pot" },
    ],
  },
  {
    id: "p1_156",
    english: "The man is folding his arms.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "접고 있다", english: "is folding" },
      { korean: "그의 팔을", english: "his arms" },
    ],
  },
  {
    id: "p1_157",
    english: "The man is putting on an apron.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "착용 중 있다", english: "is putting on" },
      { korean: "앞치마를", english: "an apron" },
    ],
  },
  {
    id: "p1_158",
    english: "The man is wiping off the counter.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "닦고 있다", english: "is wiping off" },
      { korean: "카운터를", english: "the counter" },
    ],
  },
  {
    id: "p1_159",
    english: "The woman is handing a mug to the man.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "건네주고 있다", english: "is handing" },
      { korean: "머그잔을", english: "a mug" },
      { korean: "남자에게", english: "to the man" },
    ],
  },
  {
    id: "p1_160",
    english: "Some food is being put into the freezer.",
    chunks: [
      { korean: "일부 음식이", english: "Some food" },
      { korean: "넣어지고 있다", english: "is being put" },
      { korean: "냉동고에", english: "into the freezer" },
    ],
  },
  {
    id: "p1_161",
    english: "The woman is removing the oven mitts.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "벗고 있다", english: "is removing" },
      { korean: "오븐 장갑을", english: "the oven mitts" },
    ],
  },
  {
    id: "p1_162",
    english: "The utensils are being organized.",
    chunks: [
      { korean: "주방 도구들이", english: "The utensils" },
      { korean: "정리되고 있다", english: "are being organized" },
    ],
  },
  {
    id: "p1_163",
    english: "Some food is being put into the oven.",
    chunks: [
      { korean: "일부 음식이", english: "Some food" },
      { korean: "넣어지고 있다", english: "is being put" },
      { korean: "오븐에", english: "into the oven" },
    ],
  },
  {
    id: "p1_164",
    english: "The woman is opening the cupboard.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "열고 있다", english: "is opening" },
      { korean: "찬장을", english: "the cupboard" },
    ],
  },
  {
    id: "p1_165",
    english: "One of the women is studying the menu.",
    chunks: [
      { korean: "여자들 중 한 명이", english: "One of the women" },
      { korean: "살펴보고 있다", english: "is studying" },
      { korean: "메뉴를", english: "the menu" },
    ],
  },
  {
    id: "p1_166",
    english: "The woman is searching through the cupboard.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "뒤지고 있다", english: "is searching through" },
      { korean: "찬장을", english: "the cupboard" },
    ],
  },
  {
    id: "p1_167",
    english: "The woman is tying an apron around her waist.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "묶고 있다", english: "is tying" },
      { korean: "앞치마를", english: "an apron" },
      { korean: "허리에", english: "around her waist" },
    ],
  },
  {
    id: "p1_168",
    english: "The countertop is covered in flour.",
    chunks: [
      { korean: "조리대가", english: "The countertop" },
      { korean: "덮여 있다", english: "is covered" },
      { korean: "밀가루로", english: "in flour" },
    ],
  },
  {
    id: "p1_169",
    english: "Various meals are being served to some guests.",
    chunks: [
      { korean: "다양한 음식들이", english: "Various meals" },
      { korean: "제공되고 있다", english: "are being served" },
      { korean: "몇몇 손님들에게", english: "to some guests" },
    ],
  },
  {
    id: "p1_170",
    english: "She is weighing some dry ingredients.",
    chunks: [
      { korean: "그녀는", english: "She" },
      { korean: "무게를 재고 있다", english: "is weighing" },
      { korean: "몇몇 마른 재료들을", english: "some dry ingredients" },
    ],
  },
  {
    id: "p1_171",
    english: "She is stepping on the scale.",
    chunks: [
      { korean: "그녀는", english: "She" },
      { korean: "올라서고 있다", english: "is stepping" },
      { korean: "체중계 위에", english: "on the scale" },
    ],
  },
  {
    id: "p1_172",
    english: "Some dough is left on the counter.",
    chunks: [
      { korean: "약간의 반죽이", english: "Some dough" },
      { korean: "남겨져 있다", english: "is left" },
      { korean: "조리대 위에", english: "on the counter" },
    ],
  },
  {
    id: "p1_173",
    english: "Some food is being prepared on a cutting board.",
    chunks: [
      { korean: "약간의 음식이", english: "Some food" },
      { korean: "준비되고 있다", english: "is being prepared" },
      { korean: "도마 위에", english: "on a cutting board" },
    ],
  },
  {
    id: "p1_174",
    english: "The woman is soaking vegetables in a bowl of water.",
    chunks: [
      { korean: "그 여자는", english: "The woman" },
      { korean: "담그고 있다", english: "is soaking" },
      { korean: "채소들을", english: "vegetables" },
      { korean: "물이 담긴 그릇에", english: "in a bowl of water" },
    ],
  },
  {
    id: "p1_175",
    english: "The diners are sitting in adjacent seats.",
    chunks: [
      { korean: "그 식사하는 사람들은", english: "The diners" },
      { korean: "앉아 있다", english: "are sitting" },
      { korean: "인접한 좌석에", english: "in adjacent seats" },
    ],
  },
  {
    id: "p1_176",
    english: "All the seats by the bar are taken.",
    chunks: [
      { korean: "모든 좌석이", english: "All the seats" },
      { korean: "바 옆의", english: "by the bar" },
      { korean: "차 있다", english: "are taken" },
    ],
  },
  {
    id: "p1_177",
    english: "There is a fan hanging from the ceiling.",
    chunks: [
      { korean: "선풍기가 있다", english: "There is a fan" },
      { korean: "매달려 있는", english: "hanging" },
      { korean: "천장에서", english: "from the ceiling" },
    ],
  },
  {
    id: "p1_178",
    english: "Some plates are stacked on the table.",
    chunks: [
      { korean: "몇 개의 접시가", english: "Some plates" },
      { korean: "쌓여 있다", english: "are stacked" },
      { korean: "테이블 위에", english: "on the table" },
    ],
  },
  {
    id: "p1_179",
    english: "Some light fixtures hang from the ceiling.",
    chunks: [
      { korean: "몇 개의 조명 기구가", english: "Some light fixtures" },
      { korean: "매달려 있다", english: "hang" },
      { korean: "천장에서", english: "from the ceiling" },
    ],
  },
  {
    id: "p1_180",
    english: "All the seats are occupied by people.",
    chunks: [
      { korean: "모든 좌석이", english: "All the seats" },
      { korean: "점유되어 있다", english: "are occupied" },
      { korean: "사람들에 의해", english: "by people" },
    ],
  },
  {
    id: "p1_181",
    english: "The man is rinsing the mop.",
    chunks: [
      { korean: "그 남자는", english: "The man" },
      { korean: "헹구고 있다", english: "is rinsing" },
      { korean: "대걸레를", english: "the mop" },
    ],
  },
  {
    id: "p1_182",
    english: "The man is setting aside some chairs.",
    chunks: [
      { korean: "그 남자는", english: "The man" },
      { korean: "치워두고 있다", english: "is setting aside" },
      { korean: "몇 개의 의자를", english: "some chairs" },
    ],
  },
  {
    id: "p1_183",
    english: "The woman is helping herself to the food.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      {
        korean: "스스로 음식을 덜고 있다",
        english: "is helping herself to the food",
      },
    ],
  },
  {
    id: "p1_184",
    english: "The waiter is taking an order.",
    chunks: [
      { korean: "웨이터가", english: "The waiter" },
      { korean: "받고 있다 주문을", english: "is taking an order" },
    ],
  },
  {
    id: "p1_185",
    english: "Some balloons are hanging from the ceiling.",
    chunks: [
      { korean: "몇 개의 풍선이", english: "Some balloons" },
      { korean: "매달려 있다", english: "are hanging" },
      { korean: "천장에서", english: "from the ceiling" },
    ],
  },
  {
    id: "p1_186",
    english: "The restaurant is filled with diners.",
    chunks: [
      { korean: "식당이", english: "The restaurant" },
      { korean: "가득 차 있다", english: "is filled" },
      { korean: "식사하는 사람들로", english: "with diners" },
    ],
  },
  {
    id: "p1_187",
    english: "All the chairs are filled with people.",
    chunks: [
      { korean: "모든 의자가", english: "All the chairs" },
      { korean: "가득 차 있다", english: "are filled" },
      { korean: "사람들로", english: "with people" },
    ],
  },
  {
    id: "p1_188",
    english: "Some diners are gathered at an outdoor cafe.",
    chunks: [
      { korean: "몇몇 식사하는 사람들이", english: "Some diners" },
      { korean: "모여 있다", english: "are gathered" },
      { korean: "야외 카페에", english: "at an outdoor cafe" },
    ],
  },
  {
    id: "p1_189",
    english: "Some furniture is arranged on the patio.",
    chunks: [
      { korean: "몇몇 가구가", english: "Some furniture" },
      { korean: "배치되어 있다", english: "is arranged" },
      { korean: "파티오에", english: "on the patio" },
    ],
  },
  {
    id: "p1_190",
    english: "The tables are covered with tablecloths.",
    chunks: [
      { korean: "테이블들이", english: "The tables" },
      { korean: "덮여 있다", english: "are covered" },
      { korean: "식탁보로", english: "with tablecloths" },
    ],
  },
  {
    id: "p1_191",
    english: "The plants are being watered.",
    chunks: [
      { korean: "식물들이", english: "The plants" },
      { korean: "물이 주어지고 있다", english: "are being watered" },
    ],
  },
  {
    id: "p1_192",
    english: "The chairs are positioned around the table.",
    chunks: [
      { korean: "의자들이", english: "The chairs" },
      { korean: "배치되어 있다", english: "are positioned" },
      { korean: "테이블 주변에", english: "around the table" },
    ],
  },
  {
    id: "p1_193",
    english: "The windows are covered with boards.",
    chunks: [
      { korean: "창문들이", english: "The windows" },
      { korean: "덮여 있다", english: "are covered" },
      { korean: "판자들로", english: "with boards" },
    ],
  },
  {
    id: "p1_194",
    english: "The man is sipping his drink.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "마시고 있다", english: "is sipping" },
      { korean: "그의 음료를", english: "his drink" },
    ],
  },
  {
    id: "p1_195",
    english: "The man is sitting on the porch.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "앉아 있다", english: "is sitting" },
      { korean: "현관에", english: "on the porch" },
    ],
  },
  {
    id: "p1_196",
    english: "The pans are being washed in the sink.",
    chunks: [
      { korean: "팬들이", english: "The pans" },
      { korean: "씻기고 있다", english: "are being washed" },
      { korean: "싱크대에서", english: "in the sink" },
    ],
  },
  {
    id: "p1_197",
    english: "A large boat is tied to the dock.",
    chunks: [
      { korean: "큰 배가", english: "A large boat" },
      { korean: "묶여 있다", english: "is tied" },
      { korean: "부두에", english: "to the dock" },
    ],
  },
  {
    id: "p1_198",
    english: "Two ships are passing each other on the water.",
    chunks: [
      { korean: "두 배가", english: "Two ships" },
      { korean: "지나치고 있다", english: "are passing" },
      { korean: "서로를", english: "each other" },
      { korean: "물 위에서", english: "on the water" },
    ],
  },
  {
    id: "p1_199",
    english: "The tables have a square base.",
    chunks: [
      { korean: "테이블들은", english: "The tables" },
      { korean: "가지고 있다", english: "have" },
      { korean: "정사각형 받침대를", english: "a square base" },
    ],
  },
  {
    id: "p1_200",
    english: "There are no seats left in the restaurant.",
    chunks: [
      { korean: "자리가 없다", english: "There are no seats" },
      { korean: "남아 있는", english: "left" },
      { korean: "식당에", english: "in the restaurant" },
    ],
  },
  {
    id: "p1_201",
    english: "There is flatware on the table.",
    chunks: [
      { korean: "식기가 있다", english: "There is flatware" },
      { korean: "테이블 위에", english: "on the table" },
    ],
  },
  {
    id: "p1_202",
    english: "Most of the seats are occupied.",
    chunks: [
      { korean: "대부분의 좌석이", english: "Most of the seats" },
      { korean: "점유되어 있다", english: "are occupied" },
    ],
  },
  {
    id: "p1_203",
    english: "The candles are placed on the shelf.",
    chunks: [
      { korean: "양초들이", english: "The candles" },
      { korean: "놓여 있다", english: "are placed" },
      { korean: "선반 위에", english: "on the shelf" },
    ],
  },
  {
    id: "p1_204",
    english: "There is a picture attached to the wall.",
    chunks: [
      { korean: "그림이 있다", english: "There is a picture" },
      { korean: "부착된", english: "attached" },
      { korean: "벽에", english: "to the wall" },
    ],
  },
  {
    id: "p1_205",
    english: "The dish is being passed at the table.",
    chunks: [
      { korean: "요리가", english: "The dish" },
      { korean: "전달되고 있다", english: "is being passed" },
      { korean: "테이블에서", english: "at the table" },
    ],
  },
  {
    id: "p1_206",
    english: "The people are dining on the patio.",
    chunks: [
      { korean: "사람들이", english: "The people" },
      { korean: "식사하고 있다", english: "are dining" },
      { korean: "파티오에서", english: "on the patio" },
    ],
  },
  {
    id: "p1_207",
    english: "The sales clerk is handling a product.",
    chunks: [
      { korean: "판매원이", english: "The sales clerk" },
      { korean: "다루고 있다", english: "is handling" },
      { korean: "제품을", english: "a product" },
    ],
  },
  {
    id: "p1_208",
    english: "The patio overlooks the sea.",
    chunks: [
      { korean: "파티오가", english: "The patio" },
      { korean: "내려다보고 있다", english: "overlooks" },
      { korean: "바다를", english: "the sea" },
    ],
  },
  {
    id: "p1_209",
    english: "The steps lead up to the entrance.",
    chunks: [
      { korean: "계단이", english: "The steps" },
      { korean: "이어진다", english: "lead up" },
      { korean: "입구까지", english: "to the entrance" },
    ],
  },
  {
    id: "p1_210",
    english: "A piece of cloth is draped over the table.",
    chunks: [
      { korean: "천 조각이", english: "A piece of cloth" },
      { korean: "덮여 있다", english: "is draped" },
      { korean: "테이블 위에", english: "over the table" },
    ],
  },
  {
    id: "p1_211",
    english: "The boat is unloading passengers at the dock.",
    chunks: [
      { korean: "배가", english: "The boat" },
      { korean: "내리고 있다", english: "is unloading" },
      { korean: "승객들을", english: "passengers" },
      { korean: "부두에서", english: "at the dock" },
    ],
  },
  {
    id: "p1_212",
    english: "The man is grasping a kitchen utensil.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "쥐고 있다", english: "is grasping" },
      { korean: "주방 도구를", english: "a kitchen utensil" },
    ],
  },
  {
    id: "p1_213",
    english: "She is polishing the glasses.",
    chunks: [
      { korean: "그녀가", english: "She" },
      { korean: "닦고 있다", english: "is polishing" },
      { korean: "안경을", english: "the glasses" },
    ],
  },
  {
    id: "p1_214",
    english: "The patio umbrella is folded.",
    chunks: [
      { korean: "파티오 우산이", english: "The patio umbrella" },
      { korean: "접혀 있다", english: "is folded" },
    ],
  },
  {
    id: "p1_215",
    english: "He is making a beverage.",
    chunks: [
      { korean: "그가", english: "He" },
      { korean: "만들고 있다", english: "is making" },
      { korean: "음료를", english: "a beverage" },
    ],
  },
  {
    id: "p1_216",
    english: "He is boiling some water.",
    chunks: [
      { korean: "그가", english: "He" },
      { korean: "끓이고 있다", english: "is boiling" },
      { korean: "물을", english: "some water" },
    ],
  },
  {
    id: "p1_217",
    english: "The chef is instructing the kitchen crew.",
    chunks: [
      { korean: "요리사가", english: "The chef" },
      { korean: "지시하고 있다", english: "is instructing" },
      { korean: "주방 직원들에게", english: "the kitchen crew" },
    ],
  },
  {
    id: "p1_218",
    english: "Fresh ingredients are stored in the fridge.",
    chunks: [
      { korean: "신선한 재료들이", english: "Fresh ingredients" },
      { korean: "보관되어 있다", english: "are stored" },
      { korean: "냉장고에", english: "in the fridge" },
    ],
  },
  {
    id: "p1_219",
    english: "The server is handing menus to the diners.",
    chunks: [
      { korean: "서버가", english: "The server" },
      { korean: "건네주고 있다", english: "is handing" },
      { korean: "메뉴를", english: "menus" },
      { korean: "식사하는 사람들에게", english: "to the diners" },
    ],
  },
  {
    id: "p1_220",
    english: "The women are sitting side by side.",
    chunks: [
      { korean: "여성들이", english: "The women" },
      { korean: "앉아 있다", english: "are sitting" },
      { korean: "나란히", english: "side by side" },
    ],
  },
  {
    id: "p1_221",
    english: "The bicycle is secured to a lamp post.",
    chunks: [
      { korean: "자전거가", english: "The bicycle" },
      { korean: "고정되어 있다", english: "is secured" },
      { korean: "가로등에", english: "to a lamp post" },
    ],
  },

  {
    id: "p1_222",
    english: "The woman is raking the leaves into a pile.",
    chunks: [
      { korean: "여성이", english: "The woman" },
      { korean: "갈퀴질하고 있다", english: "is raking" },
      { korean: "낙엽을", english: "the leaves" },
      { korean: "더미로", english: "into a pile" },
    ],
  },
  {
    id: "p1_223",
    english: "The woman is sweeping the leaves.",
    chunks: [
      { korean: "여성이", english: "The woman" },
      { korean: "쓸고 있다", english: "is sweeping" },
      { korean: "낙엽을", english: "the leaves" },
    ],
  },
  {
    id: "p1_224",
    english: "One of the brooms is lying on the ground.",
    chunks: [
      { korean: "빗자루 중 하나가", english: "One of the brooms" },
      { korean: "놓여 있다", english: "is lying" },
      { korean: "바닥에", english: "on the ground" },
    ],
  },
  {
    id: "p1_225",
    english: "The woman is mowing the lawn.",
    chunks: [
      { korean: "여성이", english: "The woman" },
      { korean: "깎고 있다", english: "is mowing" },
      { korean: "잔디를", english: "the lawn" },
    ],
  },
  {
    id: "p1_226",
    english: "They are maintaining the garden.",
    chunks: [
      { korean: "그들은", english: "They" },
      { korean: "관리하고 있다", english: "are maintaining" },
      { korean: "정원을", english: "the garden" },
    ],
  },
  {
    id: "p1_227",
    english: "The man is trimming the hedge.",
    chunks: [
      { korean: "남성이", english: "The man" },
      { korean: "다듬고 있다", english: "is trimming" },
      { korean: "생울타리를", english: "the hedge" },
    ],
  },
  {
    id: "p1_228",
    english: "The fence surrounds the garden.",
    chunks: [
      { korean: "울타리가", english: "The fence" },
      { korean: "둘러싸고 있다", english: "surrounds" },
      { korean: "정원을", english: "the garden" },
    ],
  },
  {
    id: "p1_229",
    english: "The man is watering the lawn.",
    chunks: [
      { korean: "남성이", english: "The man" },
      { korean: "물을 주고 있다", english: "is watering" },
      { korean: "잔디에", english: "the lawn" },
    ],
  },
  {
    id: "p1_230",
    english: "The man is trimming the tree branches.",
    chunks: [
      { korean: "남성이", english: "The man" },
      { korean: "다듬고 있다", english: "is trimming" },
      { korean: "나무 가지를", english: "the tree branches" },
    ],
  },
  {
    id: "p1_231",
    english: "The man is cutting down a tree.",
    chunks: [
      { korean: "남성이", english: "The man" },
      { korean: "베고 있다", english: "is cutting down" },
      { korean: "나무를", english: "a tree" },
    ],
  },
  {
    id: "p1_232",
    english: "The man is spraying some pesticides on his garden.",
    chunks: [
      { korean: "남성이", english: "The man" },
      { korean: "뿌리고 있다", english: "is spraying" },
      { korean: "농약을", english: "some pesticides" },
      { korean: "그의 정원에", english: "on his garden" },
    ],
  },
  {
    id: "p1_233",
    english: "The people are doing some landscaping work.",
    chunks: [
      { korean: "사람들이", english: "The people" },
      { korean: "하고 있다", english: "are doing" },
      { korean: "조경 작업을", english: "some landscaping work" },
    ],
  },
  {
    id: "p1_234",
    english: "The flowers are being arranged in a pot.",
    chunks: [
      { korean: "꽃들이", english: "The flowers" },
      { korean: "정리되고 있다", english: "are being arranged" },
      { korean: "화분에", english: "in a pot" },
    ],
  },
  {
    id: "p1_235",
    english: "He is harvesting some vegetables.",
    chunks: [
      { korean: "그는", english: "He" },
      { korean: "수확하고 있다", english: "is harvesting" },
      { korean: "몇몇 채소를", english: "some vegetables" },
    ],
  },
  {
    id: "p1_236",
    english: "The man is sowing some seeds.",
    chunks: [
      { korean: "남성이", english: "The man" },
      { korean: "뿌리고 있다", english: "is sowing" },
      { korean: "몇몇 씨앗을", english: "some seeds" },
    ],
  },
  {
    id: "p1_237",
    english: "Some plants are hanging near the window.",
    chunks: [
      { korean: "몇몇 식물이", english: "Some plants" },
      { korean: "걸려 있다", english: "are hanging" },
      { korean: "창문 근처에", english: "near the window" },
    ],
  },
  {
    id: "p1_238",
    english: "There's a bird sitting on the windowsill.",
    chunks: [
      { korean: "새가", english: "There's a bird" },
      { korean: "앉아 있다", english: "sitting" },
      { korean: "창턱에", english: "on the windowsill" },
    ],
  },
  {
    id: "p1_239",
    english: "He's doing some yard work.",
    chunks: [
      { korean: "그는", english: "He" },
      { korean: "하고 있다", english: "is doing" },
      { korean: "정원 일을", english: "some yard work" },
    ],
  },
  {
    id: "p1_240",
    english: "Some light fixtures are being installed in the room.",
    chunks: [
      { korean: "몇몇 조명 기구가", english: "Some light fixtures" },
      { korean: "설치되고 있다", english: "are being installed" },
      { korean: "방 안에", english: "in the room" },
    ],
  },
  {
    id: "p1_241",
    english: "The cushions are being removed from the sofa.",
    chunks: [
      { korean: "쿠션들이", english: "The cushions" },
      { korean: "제거되고 있다", english: "are being removed" },
      { korean: "소파에서", english: "from the sofa" },
    ],
  },
  {
    id: "p1_242",
    english: "The rug is rolled up.",
    chunks: [
      { korean: "러그가", english: "The rug" },
      { korean: "말려 있다", english: "is rolled up" },
    ],
  },
  {
    id: "p1_243",
    english: "The furniture is reflected in the mirror.",
    chunks: [
      { korean: "가구가", english: "The furniture" },
      { korean: "반사되어 있다", english: "is reflected" },
      { korean: "거울에", english: "in the mirror" },
    ],
  },
  {
    id: "p1_244",
    english: "A piece of art is mounted on the wall.",
    chunks: [
      { korean: "예술 작품이", english: "A piece of art" },
      { korean: "걸려 있다", english: "is mounted" },
      { korean: "벽에", english: "on the wall" },
    ],
  },
  {
    id: "p1_245",
    english: "The furniture is being rearranged.",
    chunks: [
      { korean: "가구가", english: "The furniture" },
      { korean: "재배치되고 있다", english: "is being rearranged" },
    ],
  },
  {
    id: "p1_246",
    english: "The table is set for a meal.",
    chunks: [
      { korean: "테이블이", english: "The table" },
      { korean: "차려져 있다", english: "is set" },
      { korean: "식사를 위해", english: "for a meal" },
    ],
  },
  {
    id: "p1_247",
    english: "There is a lamp on either side of the bed.",
    chunks: [
      { korean: "램프가 있다", english: "There is a lamp" },
      { korean: "양쪽에", english: "on either side" },
      { korean: "침대의", english: "of the bed" },
    ],
  },
  {
    id: "p1_248",
    english: "The food is being laid out.",
    chunks: [
      { korean: "음식이", english: "The food" },
      { korean: "차려지고 있다", english: "is being laid out" },
    ],
  },
  {
    id: "p1_249",
    english: "The fire is burning in the fireplace.",
    chunks: [
      { korean: "불이", english: "The fire" },
      { korean: "타고 있다", english: "is burning" },
      { korean: "벽난로에서", english: "in the fireplace" },
    ],
  },
  {
    id: "p1_250",
    english: "The fire is lit in the fireplace.",
    chunks: [
      { korean: "불이", english: "The fire" },
      { korean: "켜져 있다", english: "is lit" },
      { korean: "벽난로에서", english: "in the fireplace" },
    ],
  },
  {
    id: "p1_251",
    english: "Some reading material is placed on the couch.",
    chunks: [
      { korean: "약간의 독서 자료가", english: "Some reading material" },
      { korean: "놓여 있다", english: "is placed" },
      { korean: "소파 위에", english: "on the couch" },
    ],
  },
  {
    id: "p1_252",
    english: "The seat is pushed under the desk.",
    chunks: [
      { korean: "의자가", english: "The seat" },
      { korean: "밀려 있다", english: "is pushed" },
      { korean: "책상 아래로", english: "under the desk" },
    ],
  },
  {
    id: "p1_253",
    english: "The bedcover is straightened.",
    chunks: [
      { korean: "침대 커버가", english: "The bedcover" },
      { korean: "정돈되어 있다", english: "is straightened" },
    ],
  },
  {
    id: "p1_254",
    english: "There is a chandelier suspended from the ceiling.",
    chunks: [
      { korean: "샹들리에가", english: "There is a chandelier" },
      { korean: "매달려 있다", english: "suspended" },
      { korean: "천장에서", english: "from the ceiling" },
    ],
  },
  {
    id: "p1_255",
    english: "The room is decorated with patterned wallpaper.",
    chunks: [
      { korean: "방이", english: "The room" },
      { korean: "장식되어 있다", english: "is decorated" },
      { korean: "무늬가 있는 벽지로", english: "with patterned wallpaper" },
    ],
  },
  {
    id: "p1_256",
    english: "The steps lead up to the front door.",
    chunks: [
      { korean: "계단이", english: "The steps" },
      { korean: "이어져 있다", english: "lead up" },
      { korean: "현관문까지", english: "to the front door" },
    ],
  },
  {
    id: "p1_257",
    english: "The exterior of the house is asymmetrical.",
    chunks: [
      { korean: "집의 외관이", english: "The exterior of the house" },
      { korean: "비대칭적이다", english: "is asymmetrical" },
    ],
  },
  {
    id: "p1_258",
    english: "The lamp sits on the side table.",
    chunks: [
      { korean: "램프가", english: "The lamp" },
      { korean: "놓여 있다", english: "sits" },
      { korean: "협탁 위에", english: "on the side table" },
    ],
  },
  {
    id: "p1_259",
    english: "She is having her temperature taken.",
    chunks: [
      { korean: "그녀는", english: "She" },
      {
        korean: "체온을 재고 있다",
        english: "is having her temperature taken",
      },
    ],
  },
  {
    id: "p1_260",
    english: "The doctor is examining the patient.",
    chunks: [
      { korean: "의사가", english: "The doctor" },
      { korean: "진찰하고 있다", english: "is examining" },
      { korean: "환자를", english: "the patient" },
    ],
  },
  {
    id: "p1_261",
    english: "The patient is being treated at this clinic.",
    chunks: [
      { korean: "환자가", english: "The patient" },
      { korean: "치료받고 있다", english: "is being treated" },
      { korean: "이 병원에서", english: "at this clinic" },
    ],
  },
  {
    id: "p1_262",
    english: "The pharmacist is dispensing medication.",
    chunks: [
      { korean: "약사가", english: "The pharmacist" },
      { korean: "조제하고 있다", english: "is dispensing" },
      { korean: "약을", english: "medication" },
    ],
  },
  {
    id: "p1_263",
    english: "The woman is ironing some fabric.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "다림질하고 있다", english: "is ironing" },
      { korean: "천을", english: "some fabric" },
    ],
  },
  {
    id: "p1_264",
    english: "She's assembling some machinery.",
    chunks: [
      { korean: "그녀는", english: "She" },
      { korean: "조립하고 있다", english: "is assembling" },
      { korean: "기계를", english: "some machinery" },
    ],
  },
  {
    id: "p1_265",
    english: "She's looking through a telescope.",
    chunks: [
      { korean: "그녀는", english: "She" },
      { korean: "보고 있다", english: "is looking" },
      { korean: "망원경으로", english: "through a telescope" },
    ],
  },
  {
    id: "p1_266",
    english: "The woman is pouring liquid into a container.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "붓고 있다", english: "is pouring" },
      { korean: "액체를", english: "liquid" },
      { korean: "용기에", english: "into a container" },
    ],
  },
  {
    id: "p1_267",
    english: "The woman is loading dirty laundry.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "넣고 있다", english: "is loading" },
      { korean: "더러운 빨래를", english: "dirty laundry" },
    ],
  },

  {
    id: "p1_268",
    english: "The man is washing the porch using a garden hose.",
    chunks: [
      { korean: "남자가", english: "The man" },
      { korean: "씻고 있다", english: "is washing" },
      { korean: "현관을", english: "the porch" },
      { korean: "사용하여 정원용 호스를", english: "using a garden hose" },
    ],
  },
  {
    id: "p1_269",
    english: "The room has been remodeled.",
    chunks: [
      { korean: "방이", english: "The room" },
      { korean: "리모델링되었다", english: "has been remodeled" },
    ],
  },
  {
    id: "p1_270",
    english: "There is a paint roller leaning against the door.",
    chunks: [
      { korean: "있다", english: "There is" },
      { korean: "페인트 롤러가", english: "a paint roller" },
      { korean: "기대어", english: "is leaning" },
      { korean: "문에", english: "against the door" },
    ],
  },
  {
    id: "p1_271",
    english: "The bed has been made.",
    chunks: [
      { korean: "침대가", english: "The bed" },
      { korean: "정리되었다", english: "has been made" },
    ],
  },
  {
    id: "p1_272",
    english: "The housekeeper is making the bed.",
    chunks: [
      { korean: "가정부가", english: "The housekeeper" },
      { korean: "정리하고 있다", english: "is making" },
      { korean: "침대를", english: "the bed" },
    ],
  },
  {
    id: "p1_273",
    english: "She's knitting a scarf by hand.",
    chunks: [
      { korean: "그녀는", english: "She" },
      { korean: "뜨개질하고 있다", english: "is knitting" },
      { korean: "목도리를", english: "a scarf" },
      { korean: "손으로", english: "by hand" },
    ],
  },
  {
    id: "p1_274",
    english: "She's sewing some fabric with the machine.",
    chunks: [
      { korean: "그녀는", english: "She" },
      { korean: "바느질하고 있다", english: "is sewing" },
      { korean: "천을", english: "some fabric" },
      { korean: "기계로", english: "with the machine" },
    ],
  },
  {
    id: "p1_275",
    english: "She's tying her headband.",
    chunks: [
      { korean: "그녀는", english: "She" },
      { korean: "묶고 있다", english: "is tying" },
      { korean: "그녀의 머리띠를", english: "her headband" },
    ],
  },
  {
    id: "p1_276",
    english: "He's looking under the hood of the vehicle.",
    chunks: [
      { korean: "그는", english: "He" },
      { korean: "보고 있다", english: "is looking" },
      { korean: "후드 아래를", english: "under the hood" },
      { korean: "차량의", english: "of the vehicle" },
    ],
  },
  {
    id: "p1_277",
    english: "The man is crossing his arms.",
    chunks: [
      { korean: "남자는", english: "The man" },
      { korean: "팔짱을 끼고 있다", english: "is crossing his arms" },
    ],
  },
  {
    id: "p1_278",
    english: "The man is inspecting the car.",
    chunks: [
      { korean: "남자는", english: "The man" },
      { korean: "검사하고 있다", english: "is inspecting" },
      { korean: "자동차를", english: "the car" },
    ],
  },
  {
    id: "p1_279",
    english: "The windshield is being washed.",
    chunks: [
      { korean: "앞유리가", english: "The windshield" },
      { korean: "씻기고 있다", english: "is being washed" },
    ],
  },
  {
    id: "p1_280",
    english: "The man is scrubbing the car with a rag.",
    chunks: [
      { korean: "남자는", english: "The man" },
      { korean: "문지르고 있다", english: "is scrubbing" },
      { korean: "자동차를", english: "the car" },
      { korean: "헝겊으로", english: "with a rag" },
    ],
  },
  {
    id: "p1_281",
    english: "Some graphics are projected on the screen.",
    chunks: [
      { korean: "몇몇 그래픽이", english: "Some graphics" },
      { korean: "투사되고 있다", english: "are projected" },
      { korean: "화면에", english: "on the screen" },
    ],
  },
  {
    id: "p1_282",
    english: "The people are facing the same direction.",
    chunks: [
      { korean: "사람들은", english: "The people" },
      { korean: "향하고 있다", english: "are facing" },
      { korean: "같은 방향을", english: "the same direction" },
    ],
  },
  {
    id: "p1_283",
    english: "A lecture is taking place in the auditorium.",
    chunks: [
      { korean: "강의가", english: "A lecture" },
      { korean: "진행되고 있다", english: "is taking place" },
      { korean: "강당에서", english: "in the auditorium" },
    ],
  },
  {
    id: "p1_284",
    english: "The man is loading paper into the copy machine.",
    chunks: [
      { korean: "남자는", english: "The man" },
      { korean: "넣고 있다", english: "is loading" },
      { korean: "종이를", english: "paper" },
      { korean: "복사기에", english: "into the copy machine" },
    ],
  },
  {
    id: "p1_285",
    english: "The man is dusting the shelves.",
    chunks: [
      { korean: "남자는", english: "The man" },
      { korean: "먼지를 털고 있다", english: "is dusting" },
      { korean: "선반을", english: "the shelves" },
    ],
  },
  {
    id: "p1_286",
    english: "A conversation is taking place near the doorway.",
    chunks: [
      { korean: "대화가", english: "A conversation" },
      { korean: "진행되고 있다", english: "is taking place" },
      { korean: "출입구 근처에서", english: "near the doorway" },
    ],
  },
  {
    id: "p1_287",
    english: "The women are sitting side by side.",
    chunks: [
      { korean: "여자들은", english: "The women" },
      { korean: "앉아 있다", english: "are sitting" },
      { korean: "나란히", english: "side by side" },
    ],
  },

  {
    id: "p1_288",
    english: "The file is left unopened on the desk.",
    chunks: [
      { korean: "파일이", english: "The file" },
      { korean: "놓여 있다", english: "is left" },
      { korean: "열리지 않은 채로", english: "unopened" },
      { korean: "책상 위에", english: "on the desk" },
    ],
  },
  {
    id: "p1_289",
    english: "The man is addressing the audience.",
    chunks: [
      { korean: "남자는", english: "The man" },
      { korean: "연설하고 있다", english: "is addressing" },
      { korean: "청중에게", english: "the audience" },
    ],
  },
  {
    id: "p1_290",
    english: "The speaker is facing a group of people.",
    chunks: [
      { korean: "연사는", english: "The speaker" },
      { korean: "마주하고 있다", english: "is facing" },
      { korean: "사람들 무리를", english: "a group of people" },
    ],
  },
  {
    id: "p1_291",
    english: "The desks are separated by dividers.",
    chunks: [
      { korean: "책상들은", english: "The desks" },
      { korean: "분리되어 있다", english: "are separated" },
      { korean: "칸막이로", english: "by dividers" },
    ],
  },
  {
    id: "p1_292",
    english: "The partitions separate the workstations.",
    chunks: [
      { korean: "칸막이들은", english: "The partitions" },
      { korean: "분리하고 있다", english: "separate" },
      { korean: "작업 공간을", english: "the workstations" },
    ],
  },
  {
    id: "p1_293",
    english: "The trash bin is being emptied out.",
    chunks: [
      { korean: "쓰레기통이", english: "The trash bin" },
      { korean: "비워지고 있다", english: "is being emptied out" },
    ],
  },
  {
    id: "p1_294",
    english: "The monitor is being turned on.",
    chunks: [
      { korean: "모니터가", english: "The monitor" },
      { korean: "켜지고 있다", english: "is being turned on" },
    ],
  },
  {
    id: "p1_295",
    english: "Identical chairs surround the table.",
    chunks: [
      { korean: "똑같은 의자들이", english: "Identical chairs" },
      { korean: "둘러싸고 있다", english: "surround" },
      { korean: "테이블을", english: "the table" },
    ],
  },
  {
    id: "p1_296",
    english: "The people are walking through the forest.",
    chunks: [
      { korean: "사람들이", english: "The people" },
      { korean: "걷고 있다", english: "are walking" },
      { korean: "숲을 통해", english: "through the forest" },
    ],
  },
  {
    id: "p1_297",
    english: "The woman is strolling along the fence.",
    chunks: [
      { korean: "여자가", english: "The woman" },
      { korean: "산책하고 있다", english: "is strolling" },
      { korean: "울타리를 따라", english: "along the fence" },
    ],
  },
  {
    id: "p1_298",
    english: "The park bench is shaded by the trees.",
    chunks: [
      { korean: "공원 벤치는", english: "The park bench" },
      { korean: "그늘져 있다", english: "is shaded" },
      { korean: "나무들에 의해", english: "by the trees" },
    ],
  },
  {
    id: "p1_299",
    english: "The cyclists are pedaling down the road.",
    chunks: [
      { korean: "자전거 타는 사람들이", english: "The cyclists" },
      { korean: "페달을 밟고 있다", english: "are pedaling" },
      { korean: "도로를 따라", english: "down the road" },
    ],
  },
  {
    id: "p1_300",
    english: "The trees line both sides of the trail.",
    chunks: [
      { korean: "나무들이", english: "The trees" },
      { korean: "줄지어 있다", english: "line" },
      { korean: "오솔길의 양쪽에", english: "both sides of the trail" },
    ],
  },
  {
    id: "p1_301",
    english: "Sunshine streams through the trees.",
    chunks: [
      { korean: "햇살이", english: "Sunshine" },
      { korean: "흘러들어온다", english: "streams" },
      { korean: "나무들 사이로", english: "through the trees" },
    ],
  },
  {
    id: "p1_302",
    english: "The shadows are being cast on the ground.",
    chunks: [
      { korean: "그림자들이", english: "The shadows" },
      { korean: "드리워지고 있다", english: "are being cast" },
      { korean: "땅 위에", english: "on the ground" },
    ],
  },
  {
    id: "p1_303",
    english: "The man is shielded from the sunlight.",
    chunks: [
      { korean: "남자는", english: "The man" },
      { korean: "보호받고 있다", english: "is shielded" },
      { korean: "햇빛으로부터", english: "from the sunlight" },
    ],
  },
  {
    id: "p1_304",
    english: "A few bicycles are being assembled.",
    chunks: [
      { korean: "몇 대의 자전거가", english: "A few bicycles" },
      { korean: "조립되고 있다", english: "are being assembled" },
    ],
  },
  {
    id: "p1_305",
    english: "Several bicycles are attached to bicycle racks.",
    chunks: [
      { korean: "여러 대의 자전거가", english: "Several bicycles" },
      { korean: "부착되어 있다", english: "are attached" },
      { korean: "자전거 거치대에", english: "to bicycle racks" },
    ],
  },
  {
    id: "p1_306",
    english: "The water is flowing under the structure.",
    chunks: [
      { korean: "물이", english: "The water" },
      { korean: "흐르고 있다", english: "is flowing" },
      { korean: "구조물 아래로", english: "under the structure" },
    ],
  },
  {
    id: "p1_307",
    english: "The columns line the walkway.",
    chunks: [
      { korean: "기둥들이", english: "The columns" },
      { korean: "늘어서 있다", english: "line" },
      { korean: "보도를 따라", english: "the walkway" },
    ],
  },

  {
    id: "p1_308",
    english: "There is a multilevel building on the shore.",
    chunks: [
      { korean: "다층 건물이 있다", english: "There is a multilevel building" },
      { korean: "해안가에", english: "on the shore" },
    ],
  },
  {
    id: "p1_309",
    english: "The attraction is crawling with tourists.",
    chunks: [
      { korean: "관광 명소가", english: "The attraction" },
      { korean: "붐비고 있다", english: "is crawling" },
      { korean: "관광객들로", english: "with tourists" },
    ],
  },
  {
    id: "p1_310",
    english: "The road is lined with trees.",
    chunks: [
      { korean: "도로가", english: "The road" },
      { korean: "늘어서 있다", english: "is lined" },
      { korean: "나무들로", english: "with trees" },
    ],
  },
  {
    id: "p1_311",
    english: "The river passes through the forest.",
    chunks: [
      { korean: "강이", english: "The river" },
      { korean: "지나간다", english: "passes" },
      { korean: "숲을 통해", english: "through the forest" },
    ],
  },
  {
    id: "p1_312",
    english: "The trees are reflected in the lake.",
    chunks: [
      { korean: "나무들이", english: "The trees" },
      { korean: "비치고 있다", english: "are reflected" },
      { korean: "호수에", english: "in the lake" },
    ],
  },
  {
    id: "p1_313",
    english: "The leaves are scattered on the ground.",
    chunks: [
      { korean: "잎들이", english: "The leaves" },
      { korean: "흩어져 있다", english: "are scattered" },
      { korean: "땅에", english: "on the ground" },
    ],
  },
  {
    id: "p1_314",
    english: "The clouds are reflected in the lake.",
    chunks: [
      { korean: "구름들이", english: "The clouds" },
      { korean: "비치고 있다", english: "are reflected" },
      { korean: "호수에", english: "in the lake" },
    ],
  },
  {
    id: "p1_315",
    english: "The ferry is sailing the sea.",
    chunks: [
      { korean: "페리가", english: "The ferry" },
      { korean: "항해하고 있다", english: "is sailing" },
      { korean: "바다를", english: "the sea" },
    ],
  },
  {
    id: "p1_316",
    english: "The structure has arched windows.",
    chunks: [
      { korean: "그 구조물은", english: "The structure" },
      { korean: "가지고 있다", english: "has" },
      { korean: "아치형 창문들을", english: "arched windows" },
    ],
  },
  {
    id: "p1_317",
    english: "The lawn is covered in leaves.",
    chunks: [
      { korean: "잔디가", english: "The lawn" },
      { korean: "덮여 있다", english: "is covered" },
      { korean: "낙엽으로", english: "in leaves" },
    ],
  },
  {
    id: "p1_318",
    english: "The clothes are hung out to dry.",
    chunks: [
      { korean: "옷들이", english: "The clothes" },
      { korean: "널려 있다", english: "are hung out" },
      { korean: "말리기 위해", english: "to dry" },
    ],
  },
  {
    id: "p1_319",
    english: "Several buildings overlook the sea.",
    chunks: [
      { korean: "여러 건물들이", english: "Several buildings" },
      { korean: "내려다보고 있다", english: "overlook" },
      { korean: "바다를", english: "the sea" },
    ],
  },
  {
    id: "p1_320",
    english: "Some leaves have fallen on the ground.",
    chunks: [
      { korean: "몇몇 낙엽들이", english: "Some leaves" },
      { korean: "떨어져 있다", english: "have fallen" },
      { korean: "땅에", english: "on the ground" },
    ],
  },
  {
    id: "p1_321",
    english: "Some goods are being paid for at the counter.",
    chunks: [
      { korean: "몇몇 상품들이", english: "Some goods" },
      { korean: "지불되고 있다", english: "are being paid for" },
      { korean: "카운터에서", english: "at the counter" },
    ],
  },
  {
    id: "p1_322",
    english: "The man is rolling up his sleeves.",
    chunks: [
      { korean: "그 남자는", english: "The man" },
      { korean: "걷어올리고 있다", english: "is rolling up" },
      { korean: "그의 소매를", english: "his sleeves" },
    ],
  },
  {
    id: "p1_323",
    english: "She is reaching for a book.",
    chunks: [
      { korean: "그녀는", english: "She" },
      { korean: "손을 뻗고 있다", english: "is reaching" },
      { korean: "책을 향해", english: "for a book" },
    ],
  },
  {
    id: "p1_324",
    english: "The storekeeper is shelving the merchandise.",
    chunks: [
      { korean: "그 가게 주인은", english: "The storekeeper" },
      { korean: "진열하고 있다", english: "is shelving" },
      { korean: "상품을", english: "the merchandise" },
    ],
  },
  {
    id: "p1_325",
    english: "An assortment of items are displayed on the store's shelves.",
    chunks: [
      { korean: "다양한 물품들이", english: "An assortment of items" },
      { korean: "진열되어 있다", english: "are displayed" },
      { korean: "가게의 선반에", english: "on the store's shelves" },
    ],
  },
  {
    id: "p1_326",
    english: "One of the women is wheeling the cart.",
    chunks: [
      { korean: "여성들 중 한 명이", english: "One of the women" },
      { korean: "끌고 있다", english: "is wheeling" },
      { korean: "카트를", english: "the cart" },
    ],
  },
  {
    id: "p1_327",
    english: "The salesperson is handing the customer her purchase.",
    chunks: [
      { korean: "그 판매원은", english: "The salesperson" },
      { korean: "건네주고 있다", english: "is handing" },
      {
        korean: "고객에게 그녀의 구매품을",
        english: "the customer her purchase",
      },
    ],
  },
  {
    id: "p1_328",
    english: "The clothes are stacked neatly on some racks.",
    chunks: [
      { korean: "그 옷들은", english: "The clothes" },
      { korean: "깔끔하게 쌓여 있다", english: "are stacked neatly" },
      { korean: "일부 선반에", english: "on some racks" },
    ],
  },
  {
    id: "p1_329",
    english: "Some clothing items are displayed in the store.",
    chunks: [
      { korean: "일부 의류 품목들이", english: "Some clothing items" },
      { korean: "진열되어 있다", english: "are displayed" },
      { korean: "상점 안에", english: "in the store" },
    ],
  },
  {
    id: "p1_330",
    english: "Several newspapers are being published.",
    chunks: [
      { korean: "여러 신문들이", english: "Several newspapers" },
      { korean: "발행되고 있다", english: "are being published" },
    ],
  },
  {
    id: "p1_331",
    english: "Some people are browsing in the bookstore.",
    chunks: [
      { korean: "몇몇 사람들이", english: "Some people" },
      { korean: "둘러보고 있다", english: "are browsing" },
      { korean: "서점에서", english: "in the bookstore" },
    ],
  },
  {
    id: "p1_332",
    english: "The woman is riding the elevator.",
    chunks: [
      { korean: "여자는", english: "The woman" },
      { korean: "타고 있다", english: "is riding" },
      { korean: "엘리베이터를", english: "the elevator" },
    ],
  },
  {
    id: "p1_333",
    english: "The man is leaning against the railings.",
    chunks: [
      { korean: "남자는", english: "The man" },
      { korean: "기대고 있다", english: "is leaning" },
      { korean: "난간에", english: "against the railings" },
    ],
  },
  {
    id: "p1_334",
    english: "Fresh produce is displayed at the market.",
    chunks: [
      { korean: "신선한 농산물이", english: "Fresh produce" },
      { korean: "진열되어 있다", english: "is displayed" },
      { korean: "시장에서", english: "at the market" },
    ],
  },
  {
    id: "p1_335",
    english: "Several items are being bagged for sale.",
    chunks: [
      { korean: "여러 물품들이", english: "Several items" },
      { korean: "포장되고 있다", english: "are being bagged" },
      { korean: "판매를 위해", english: "for sale" },
    ],
  },
  {
    id: "p1_336",
    english: "The women are buying shoelaces.",
    chunks: [
      { korean: "여자들은", english: "The women" },
      { korean: "구매하고 있다", english: "are buying" },
      { korean: "신발끈을", english: "shoelaces" },
    ],
  },
  {
    id: "p1_337",
    english: "The shopper is reaching for the handbag.",
    chunks: [
      { korean: "쇼핑객은", english: "The shopper" },
      { korean: "손을 뻗고 있다", english: "is reaching" },
      { korean: "핸드백을 향해", english: "for the handbag" },
    ],
  },
  {
    id: "p1_338",
    english: "Some merchandise is behind the glass.",
    chunks: [
      { korean: "일부 상품이", english: "Some merchandise" },
      { korean: "있다", english: "is" },
      { korean: "유리 뒤에", english: "behind the glass" },
    ],
  },
  {
    id: "p1_339",
    english: "Some hats are available for purchase.",
    chunks: [
      { korean: "일부 모자들이", english: "Some hats" },
      { korean: "구매 가능하다", english: "are available" },
      { korean: "구매를 위해", english: "for purchase" },
    ],
  },
  {
    id: "p1_340",
    english: "Some items are being paid for.",
    chunks: [
      { korean: "일부 물품들이", english: "Some items" },
      { korean: "지불되고 있다", english: "are being paid for" },
    ],
  },
  {
    id: "p1_341",
    english: "Some spectators are sitting on the grass.",
    chunks: [
      { korean: "일부 관중들이", english: "Some spectators" },
      { korean: "앉아 있다", english: "are sitting" },
      { korean: "잔디 위에", english: "on the grass" },
    ],
  },
  {
    id: "p1_342",
    english: "The athletes are racing at a track and field stadium.",
    chunks: [
      { korean: "운동선수들이", english: "The athletes" },
      { korean: "경주하고 있다", english: "are racing" },
      { korean: "육상 경기장에서", english: "at a track and field stadium" },
    ],
  },
  {
    id: "p1_343",
    english: "The woman is clearing the hurdle.",
    chunks: [
      { korean: "여자는", english: "The woman" },
      { korean: "넘고 있다", english: "is clearing" },
      { korean: "허들을", english: "the hurdle" },
    ],
  },
  {
    id: "p1_344",
    english: "The trees are growing in front of the building.",
    chunks: [
      { korean: "나무들이", english: "The trees" },
      { korean: "자라고 있다", english: "are growing" },
      { korean: "건물 앞에", english: "in front of the building" },
    ],
  },
  {
    id: "p1_345",
    english: "Some people are waiting on the sidewalk.",
    chunks: [
      { korean: "일부 사람들이", english: "Some people" },
      { korean: "기다리고 있다", english: "are waiting" },
      { korean: "보도에서", english: "on the sidewalk" },
    ],
  },
  {
    id: "p1_346",
    english: "The train is traveling along the track.",
    chunks: [
      { korean: "기차가", english: "The train" },
      { korean: "이동하고 있다", english: "is traveling" },
      { korean: "선로를 따라", english: "along the track" },
    ],
  },
  {
    id: "p1_347",
    english: "A pedestrian is crossing the street.",
    chunks: [
      { korean: "보행자가", english: "A pedestrian" },
      { korean: "건너고 있다", english: "is crossing" },
      { korean: "거리를", english: "the street" },
    ],
  },
  {
    id: "p1_348",
    english: "The train is departing from the station.",
    chunks: [
      { korean: "기차가", english: "The train" },
      { korean: "출발하고 있다", english: "is departing" },
      { korean: "역에서", english: "from the station" },
    ],
  },
  {
    id: "p1_349",
    english: "A car is being towed by a truck.",
    chunks: [
      { korean: "자동차가", english: "A car" },
      { korean: "견인되고 있다", english: "is being towed" },
      { korean: "트럭에 의해", english: "by a truck" },
    ],
  },
  {
    id: "p1_350",
    english: "The bus is leaving the bus stop.",
    chunks: [
      { korean: "버스가", english: "The bus" },
      { korean: "떠나고 있다", english: "is leaving" },
      { korean: "버스 정류장을", english: "the bus stop" },
    ],
  },
];
